export type MenuSearchItem = {
  name: string;
  url: string;
  subtitle?: Array<string>;
};

export enum MenuSearchResultBlockVariant {
  SUGGESTIONS = 'keywords',
  CONTENT = 'content',
  BRANDS = 'brands',
  CATEGORIES = 'categories',
  BRAND_AS_CATEGORIES = 'brand_as_categories',
}

export type MenuSearchItemGroup = {
  type: MenuSearchResultBlockVariant;
  items: Array<MenuSearchItem>;
  enableSuggestionFill: boolean;
  showTextSubtle: boolean;
};

export type MenuSearchItemGrouping = Partial<Record<MenuSearchResultBlockVariant, MenuSearchItemGroup>>;
